import { useEffect, useRef } from 'react'

export function usePrevious(value) {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  }, [value])

  // Intentional: the ref holds the value from the previous commit (the effect
  // updates it after render), which is exactly what `usePrevious` must return.
  // eslint-disable-next-line react-hooks/refs
  return ref.current
}
